import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
// import CloudUpload from '@mui/icons-material/CloudUpload';
import { CloudUpload } from 'lucide-react';
import Search from '@mui/icons-material/Search';
import Modal from '@mui/material/Modal';
import InputAdornment from '@mui/material/InputAdornment';
import { useSelector, useDispatch } from 'react-redux';

import LangSelectModal from './langSelect/LangSelectModal';

import { setSidebarToggled } from '@modules/ui';

import '@resources/assets/styles/_header.scss';
import HeaderMenu from './langSelect/HeaderMenu';

const Header = () => {
  const sidebarToggled = useSelector(state => state.ui.sidebarToggled);
  const userData = useSelector(state => state.organization.userData);
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // 추가: 모달 열기 상태

  const toggleModal = () => {
    setIsOpen(!isOpen); // 모달 열기/닫기 토글
  };
  const handleOpenUserMenu = (e) => {
    setAnchorElUser(e.currentTarget);
    setOpenMenu(prev => !prev);
  };

  // const mobileMenuId = 'primary-search-account-menu-mobile';
  // const renderMobileMenu = (
  //   <Menu
  //     anchorEl={mobileMoreAnchorEl}
  //     anchorOrigin={{
  //       vertical: 'top',
  //       horizontal: 'right',
  //     }}
  //     id={mobileMenuId}
  //     keepMounted
  //     transformOrigin={{
  //       vertical: 'top',
  //       horizontal: 'right',
  //     }}
  //     open={isMobileMenuOpen}
  //     onClose={handleMobileMenuClose}
  //   >
  //     <MenuItem>
  //       <IconButton size="large" aria-label="show 4 new mails" color="inherit">
  //         <Badge badgeContent={4} color="error">
  //           <MailIcon />
  //         </Badge>
  //       </IconButton>
  //       <p>Messages</p>
  //     </MenuItem>
  //     <MenuItem>
  //       <IconButton
  //         size="large"
  //         aria-label="show 17 new notifications"
  //         color="inherit"
  //       >
  //         <Badge badgeContent={17} color="error">
  //           <NotificationsIcon />
  //         </Badge>
  //       </IconButton>
  //       <p>Notifications</p>
  //     </MenuItem>
  //     <MenuItem onClick={handleProfileMenuOpen}>
  //       <IconButton
  //         size="large"
  //         aria-label="account of current user"
  //         aria-controls="primary-search-account-menu"
  //         aria-haspopup="true"
  //         color="inherit"
  //       >
  //         <AccountCircle />
  //       </IconButton>
  //       <p>Profile</p>
  //     </MenuItem>
  //   </Menu>
  // );

  return (
    <Box id="header-root">
      <AppBar
        id="wrapper-header"
        position="static"
        className="header-appbar"
      >
        <Toolbar className="header-toolbar">
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            className="header-menu-btn"
            onClick={() => dispatch(setSidebarToggled(!sidebarToggled))}
          >
            <MenuIcon />
          </IconButton>
          {IS_DEV && (
            <Box
              component="div"
              className="header-search-button"
              onClick={() => setShow(true)}
            >
              <Search fontSize="small" className="header-search-icon" />
              <Typography variant="body2" className="header-search-text">
                Search...
              </Typography>
            </Box>
          )}
          <Box className="header-grow" />
          <Box className="header-avatar-box">
            <IconButton
              size="medium"
              aria-label="show"
              aria-haspopup="true"
              color="inherit"
              onClick={(e) => handleOpenUserMenu(e)}
              className="header-avatar-btn"
            >
              <Avatar alt={userData.username} className="header-avatar-img" src="https://csms39.moodler.kr/theme/image.php/coursemos/core/1752137452/u/f2" />
            </IconButton>
            <HeaderMenu openMenu={openMenu} setOpenMenu={setOpenMenu} anchorElUser={anchorElUser} toggleModal={toggleModal} />
          </Box>
        </Toolbar>

        <Modal
          open={show}
          onClose={() => setShow(false)}
          aria-labelledby="search-modal"
          aria-describedby="search-modal-description"
          disablePortal
        >
          <Box id="header-search-modal">
            <OutlinedInput
              fullWidth
              placeholder="Search docs"
              aria-label="Search docs"
              className="header-search-input"
              endAdornment={
                <InputAdornment position="end" className="header-search-adornment">
                  <Search />
                </InputAdornment>
              }
            />
            <Typography variant="body2" className="header-search-empty">
              No recent searches
            </Typography>
          </Box>
        </Modal>

        <LangSelectModal isOpen={isOpen} toggleModal={toggleModal} />
      </AppBar>
    </Box>
  );
};

export default Header;